import React from "react";
import { Send } from "lucide-react";

/**
 * Composer row at the bottom of the chat panel. Enter submits; Shift+Enter
 * inserts a newline. Send button is disabled while a reply is pending.
 */
export default function AIChatComposer({ value, onChange, onSend, pending }) {
  const onKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };
  return (
    <div className="border-t border-slate-200 p-3 flex items-end gap-2 bg-white">
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKey}
        rows={1}
        placeholder="Ask anything…"
        className="flex-1 text-[15px] leading-relaxed resize-none rounded-md border border-slate-200 px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-indigo-500/30 max-h-[140px]"
        data-testid="ai-input"
      />
      <button
        onClick={onSend}
        disabled={pending || !value.trim()}
        className="p-2.5 rounded-md bg-indigo-600 hover:bg-indigo-700 text-white disabled:opacity-40"
        data-testid="ai-send-btn"
        aria-label="Send"
      >
        <Send size={16} />
      </button>
    </div>
  );
}
